module.exports = __webpack_public_path__ + "img/jackpot-icon.37673186.png";